<template>
  <header class="sticky top-0 z-50">
    <PromoTopBar />
    <div class="h-1 bg-gradient-brand" />
    <div class="nav-bar">
      <div class="container-site flex h-16 items-center justify-between">
        <RouterLink to="/" class="flex items-center gap-2.5">
          <img
            v-if="logo.imageUrl"
            :src="logo.imageUrl"
            :alt="logo.alt"
            class="h-10 w-auto max-w-[140px] object-contain"
          />
          <div
            v-else
            class="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-brand text-sm font-bold text-white"
          >
            {{ logo.initials }}
          </div>
          <span v-if="!logo.imageUrl" class="hidden font-bold text-slate-900 sm:block">{{ brand.name }}</span>
        </RouterLink>

        <nav class="hidden items-center gap-0.5 lg:flex" aria-label="Main navigation">
          <RouterLink
            v-for="link in navLinks"
            :key="link.to"
            :to="link.to"
            class="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:text-brand-orange"
            active-class="!text-brand-orange !font-semibold"
          >
            {{ link.label }}
          </RouterLink>
        </nav>

        <div class="flex items-center gap-2">
          <BaseButton :href="homeCtas.bookConsultation.href" variant="primary" class="!hidden !whitespace-nowrap !px-4 !py-2.5 text-sm lg:!inline-flex">
            {{ homeCtas.bookConsultation.label }}
          </BaseButton>
          <button
            type="button"
            class="glass-menu-btn"
            aria-label="Toggle menu"
            @click="mobileOpen = !mobileOpen"
          >
            <svg v-if="!mobileOpen" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <Transition name="fade-up">
        <MobileNav v-if="mobileOpen" @close="mobileOpen = false" />
      </Transition>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { brand, navLinks, logo, homeCtas } from '@/config/site'
import BaseButton from '@/components/ui/BaseButton.vue'
import MobileNav from '@/components/layout/MobileNav.vue'
import PromoTopBar from '@/components/promo/PromoTopBar.vue'

const mobileOpen = ref(false)
</script>
